<div class="main">
  <h1>Core Detail Changes</h1>
</div>
